import type { PhraseDescription } from '~/features/catalog-operations/types/catalog-operations.types';

/** True when a phrase-description row carries anything worth rendering. The row
 *  can exist with every field null — a strategy that ran and produced nothing —
 *  which is the empty state, not a section full of absent levels.
 *
 *  Split out of `search-descriptors.tsx` (a plain-function export there tripped
 *  the fast-refresh-only-components lint rule) so both that tab and the Product
 *  Description row's "Phrase Descriptions" toggle can share the same check. */
export function hasDescriptionContent(phrase: PhraseDescription): boolean {
  // Level 3 only — it's the sole level rendered (and delivered), so a row with
  // just the original / Levels 1–2 has nothing to show. A Level 3 error still
  // counts: it renders as an explanation. Blank strings count as absent.
  return [phrase.level3Description, phrase.level3Error].some(
    (value) => value !== null && value.trim() !== '',
  );
}
